<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #drawer
    class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false && !!token"
  >
    @if (!!token) {
    <div class="sidenav-profile">
      <div class="sidenav-avatar-wrap">
        <img
          class="sidenav-avatar"
          fhImageUrl
          [originalUrl]="profilePic() || defaultProfilePic"
          alt="Profile picture"
        />
        <button
          type="button"
          class="sidenav-avatar-edit"
          [class.sidenav-avatar-edit--prompt]="!profilePic()"
          [disabled]="isUploadingProfilePic()"
          [matTooltip]="profilePic() ? 'Change profile picture' : 'Upload a photo'"
          [attr.aria-label]="profilePic() ? 'Change profile picture' : 'Upload a photo'"
          (click)="openProfilePicPicker()"
        >
          <mat-icon class="sidenav-avatar-edit-icon">
            {{ isUploadingProfilePic() ? "hourglass_empty" : "photo_camera" }}
          </mat-icon>
        </button>
        <input
          #profilePicInput
          type="file"
          accept="image/*"
          style="display: none"
          (change)="onProfilePicSelected($event)"
        />
      </div>
      <span class="sidenav-username">{{ username }}</span>
    </div>

    <mat-nav-list class="sidenav-menu">
      @for (menuItem of menuItems; track menuItem) {
      <a
        mat-list-item
        class="nav-link"
        [routerLinkActive]="'active'"
        [routerLink]="[menuItem.path]"
      >
        <mat-icon>{{ menuItem.icon }}</mat-icon>
        <span>{{ menuItem.title }}</span>
        @if (menuItem.path === "/messages" && chatService.unreadCount() > 0) {
        <span class="nav-badge" [attr.aria-label]="chatService.unreadCount() + ' unread messages'">
          {{ chatService.unreadCount() > 99 ? "99+" : chatService.unreadCount() }}
        </span>
        }
      </a>
      }
    </mat-nav-list>

    <button type="button" class="sidenav-logout" (click)="logout()">
      <mat-icon>settings_power</mat-icon>
      <span>Logout</span>
    </button>
    }
  </mat-sidenav>
  <mat-sidenav-content>
    @if (isHandset$ | async) {
    <div class="mobile-toggle-bar">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
      >
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
    </div>
    }
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
